export default "__VITE_ASSET__60deb5fe__"